import React, { createContext, useEffect, useMemo, useState } from 'react';
import { useLocation, useHistory, Switch, Route } from 'react-router-dom';
import qs from 'qs';
import { appearanceConfiguration } from '../../services/endpoints/appearance';
import { getErrorMessage } from '../../utils/helper';
import PageNotFound from '../404';
import { routesAppearance } from './helpers';
import Loader from '../../components/Loaders/Loader';
import { allRoutes } from '../../routers/modules';

export const AppearanceContext = createContext({});
const Appearance = () => {
  const location = useLocation();
  const history = useHistory();

  const queryString = qs.parse(location.search.slice(1));

  const routeAppearance = useMemo(() => allRoutes.find((route) => route.name === 'Appearance'), [])

  const [init, setInit] = useState(false);
  const [config, setConfig] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(location.pathname);
  const [error, setError] = useState(null);

  const menu = useMemo(() => {
    if (config.appearances) {
      return config.appearances.map((route) => {
        const { title, url } = route;
        const clearAdminUrl = url.replace('admin/', '');

        const pagesRoutesSecondary = routesAppearance.reduce((accumulator, currentValue) => {
          if (currentValue?.menu === route.code) {
            accumulator.push(currentValue.link)
          }
          return accumulator;
        }, [])

        return {
          url: clearAdminUrl,
          react: true,
          routesSecondary: pagesRoutesSecondary,
          title,
        }
      })
    }
    return []
  }, [config])

  useEffect(() => {
    if (location.pathname !== activeTab) {
      const clearAdminActiveTab = activeTab.replace('admin/', '');
      history.replace({
        pathname: clearAdminActiveTab,
        search: location.search,
      }, { config });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab])

  useEffect(() => {
    if (location.pathname !== activeTab) {
      const clearAdminActiveTab = location.pathname.replace('admin/', '');
      if (clearAdminActiveTab === routeAppearance.link) {
        setInit(false);
        setActiveTab(routeAppearance.link)
      }
      history.replace({
        pathname: clearAdminActiveTab,
        search: location.search,
      }, { config });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname])

  const fetchConfig = async () => {
    setIsLoading(true);
    try {
      const response = await appearanceConfiguration(queryString);
      if (response.success) {
        setConfig(response.data);
        /* Если переход на страницу Appearance, то редиректим на первую из конфига */
        if (routeAppearance.link === activeTab || `${routeAppearance.link}/` === activeTab) {
          const firstUrl = response.data?.appearances[0]?.url;
          if (!firstUrl) {
            throw new Error('First url not found')
          }
          const findFirstRoute = [...routesAppearance].find((route) => route.link === firstUrl.replace('admin/', ''))
          if (!findFirstRoute?.react) {
            window.location.href = firstUrl
            return;
          }
          setActiveTab(firstUrl);
        }
      }
      setInit(true);
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      setError(errorMessage)
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!init) {
      fetchConfig()
      document.title = 'Appearance';
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, init]);

  if (isLoading && !init) {
    return <Loader />;
  }

  if (error) {
    return <PageNotFound errorDataMessage={error} errorStatusText="Error" />
  }

  return (
    <AppearanceContext.Provider
      value={{
        config,
        menu,
      }}
    >
      <Switch>
        <>
          {routesAppearance.map((route, index) => (
            <Route key={`appearance-route-${index}`} exact path={route.link}>
              <route.component />
            </Route>
          ))}
        </>
      </Switch>
    </AppearanceContext.Provider>
  );
};

export default Appearance;
